<template>
  <div
    :id="`tabpanel-${index}`"
    role="tabpanel"
    :aria-labelledby="`tab-${index}`"
    class="collection-tabs-item"
  >
    <StoryblokComponent :blok="blok" :level="1" tag="div" />
  </div>
</template>

<script setup>
defineProps({
  index: {
    type: Number,
    required: true,
  },
  blok: {
    type: Object,
    required: true,
  },
});
</script>
